import React from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { Card, Col, Input, Label, Row, Table } from 'reactstrap';

import styles from './style.module.scss';

import InfoIcon from '../../../assets/images/icons/info.svg';
import EditIcon from '../../../assets/images/icons/edit.svg';

import { IPhasingData, IPhasingPayload, IPhasingRow } from '../../../interfaces/strategic-plan-phasing.interface';
import { GetPhasingData, UpdatePhasingData } from '../../../api-services/strategic-plan.api';
import { FreezePlan } from '../../../api-services/strategic-plan.api';

import {
  GetPlanId,
  getRatioSelectionOfPhasingGrid,
  OneDecimalPlace
} from '../../../helpers/Helpers';
import {
  calculateGrandTotal,
  calculateGrandTotalComparision,
  calculateHorizontalPrevValue, calculateHorizontalQuarterPct,
  calculatePercentageValue,
  calculateProductGrandTotal,
  calculateProductGrandTotalComparision,
  calculateQuarterPct,
  calculateQuarterTotal,
  calculateQuarterTotalComparision,
  calculateTotalHorizontalQuarterEdit,
  calculateTotalHorizontalWeekEdit,
  calculateTotalVerticalEdit,
  calculateTotalVerticalQuarterEdit,
  calculateTotalVerticalWeekEdit,
  calculateVerticalQuarterPct,
  calculateVerticalQuarterTotal,
  calculateVerticalQuarterTotalComparision,
  calculateVerticalTotal,
  calculateVerticalTotalPct,
  calculateVerticalWeekPct,
  calculateVerticalWeekTotal,
  calculateVerticalWeekTotalComparision,
  totalWeeksOfSelectedQuarter
} from './helper';

import InitialMessage from '../../../components/Common/initial-message/initial-message';
import NoDataFound from '../../../components/Common/no-data-found/no-data-found';
import InvalidData from '../../../components/Common/invalid-data/invalid-data';
import ActionCard from '../../../components/Footer/ActionCard';
import UnsavedDataModal from '../../../components/Common/Modals/UnsavedDataModal';
import Tooltip from '../../../components/Common/tooltip/tooltip';
import SuccessModal from '../../../components/Common/Modals/SuccessModal';

import { UpdateEditRestriction } from '../../../store/action-restriction/actions';
import { UpdatePhasingDataSource, UpdatePhasingType } from '../../../store/phasing-data/actions';

interface OwnProps {
  history: any;
  isCallRequired: boolean;
  onUpdateStart: () => void;
  onUpdateEnd: () => void;
  onLoadEnd: () => void;
  onRunningEnd: () => void;
}

interface StateProps {
  isAllowed: boolean;
}

interface DispatchProps {
  UpdateEditRestriction: (isAllowed: boolean) => void;
  UpdatePhasingDataSource: (dataSource: IPhasingRow[]) => void;
  UpdatePhasingType: (type: string) => void;
}

type Props = StateProps & DispatchProps & OwnProps;

interface State {
  isAutoLoad:boolean;
  isLoading: boolean;
  isExpanded: boolean;
  selectedTab: string;
  originalDataSource: IPhasingData;
  dataSource: IPhasingData;
  phasingToggle: string;
  comparisionMetricsList: {
    label: string;
    value: string;
  }[];
  comparisionMetrics: string;
  editTotal: boolean;
  editCells: boolean;
  isEditRestrictionAllowed: boolean;
  extraRow: any[];
  isRunningModal: boolean;
}

class PhasingTable extends React.Component<Props, State> {
  constructor(props) {
    super(props);

    this.state = {
      isAutoLoad:true,
      isLoading: true,
      isExpanded: true,
      selectedTab: 'Units',
      originalDataSource: { columns: [], rows: [] },
      dataSource: { columns: [], rows: [] },
      phasingToggle: 'Vertical',
      comparisionMetricsList: [
        { label: 'None', value: 'None' },
        { label: 'LY Actuals', value: 'ly' },
        { label: 'LQ Actuals', value: 'lq' }
      ],
      comparisionMetrics: 'None',
      editTotal: false,
      editCells: false,
      isEditRestrictionAllowed: false,
      extraRow: [],
      isRunningModal: false
    };
  }

  componentDidMount(): void {
    //this.getPhasingData();
    this.setState({ isLoading: false }); 
    this.props.onLoadEnd();
  }

  componentDidUpdate(prevProps, prevState): void {
    if (!prevProps.isCallRequired && this.props.isCallRequired) {
      this.setState({
        isLoading: true
      }, () => {
        this.getPhasingData();
      });
    }
  }

  getPhasingData(): void {
    const params = {
      userId: sessionStorage.getItem('userName'),
      planId: GetPlanId(this.props.history.location.pathname),
    };

    GetPhasingData(params)
      .then((res: IPhasingData) => {
        this.setState({
          originalDataSource: !!res ? res : { columns: [], rows: [] },
          isLoading: false,isAutoLoad: false,
        }, () => {
          if (this.validateJSON() && !this.state.isRunningModal) {
            this.dataInit();
          }
          if (this.state.isLoading) {
            this.props.onLoadEnd();
          }
        });
      });
  }

  validateJSON(): boolean {
    let valid = true;

    const quarterLength = this.state.originalDataSource.columns.length;
    valid = valid && this.state.originalDataSource.rows
      .reduce((rInit, row) => rInit && row.quarters.length === quarterLength, true);

    const weekLength = this.state.originalDataSource.columns.reduce((colInit, col) => {
      colInit += col.months.length;
      return colInit;
    }, 0);

    valid = valid && this.state.originalDataSource.rows
      .reduce((rInit, row) => rInit && row.quarters
        .reduce((qInit, quarter) => {
          qInit += quarter.months.length;
          return qInit;
        }, 0) === weekLength, true);

    return valid;
  }

  dataInit(): void {
    const dataSource: IPhasingData = { ...this.state.originalDataSource };
    const data: IPhasingData = {
      columns: dataSource.columns.map((col) => {
        return {
          ...col,
          isExpanded: col.isExpanded,
        };
      }),
      rows: dataSource.rows.map((row) => {
        const pctR = this.state.phasingToggle === 'Vertical'
          ? calculatePercentageValue(
            calculateProductGrandTotal(row.quarters, this.state.selectedTab),
            calculateGrandTotal(dataSource.rows, this.state.selectedTab)
          )
          : 100;

        return {
          ...row,
          value: calculateProductGrandTotal(row.quarters, this.state.selectedTab),
          oldValue: calculateProductGrandTotal(row.quarters, this.state.selectedTab),
          pctValue: pctR,
          pctOldValue: pctR,
          pctTotal: 0,
          comparisionPctValue: this.state.phasingToggle === 'Vertical'
            ? calculatePercentageValue(
              calculateProductGrandTotalComparision(row.quarters, this.state.selectedTab, this.state.comparisionMetrics),
              calculateGrandTotalComparision(dataSource.rows, this.state.selectedTab, this.state.comparisionMetrics)
            )
            : 100,
          quarters: row.quarters.map((quarter, qIdx: number) => {
            const pctQ = calculatePercentageValue(
              calculateQuarterTotal(quarter.months, this.state.selectedTab),
              this.state.phasingToggle === 'Vertical'
                ? calculateVerticalQuarterTotal(dataSource.rows, qIdx, this.state.selectedTab)
                : calculateProductGrandTotal(
                //quarter.isPast
                row.quarters,
                //: row.quarters.filter((quarter) => !quarter.isPast),
                this.state.selectedTab
                )
            );

            return {
              ...quarter,
              isEdited: false,
              isDisabled: false,
              value: calculateQuarterTotal(quarter.months, this.state.selectedTab),
              oldValue: calculateQuarterTotal(quarter.months, this.state.selectedTab),
              pctValue: pctQ,
              pctOldValue: pctQ,
              pctTotal: 0,
              comparisionPctValue: calculatePercentageValue(
                calculateQuarterTotalComparision(quarter.months, this.state.selectedTab, this.state.comparisionMetrics),
                this.state.phasingToggle === 'Vertical'
                  ? calculateVerticalQuarterTotalComparision(dataSource.rows, qIdx, this.state.selectedTab, this.state.comparisionMetrics)
                  : calculateProductGrandTotalComparision(
                  //quarter.isPast
                  row.quarters,
                  //: row.quarters.filter((quarter) => !quarter.isPast),
                  this.state.selectedTab,
                  this.state.comparisionMetrics
                  )
              ),
              months: quarter.months.map((month, mIdx: number) => {
                const pctW = calculatePercentageValue(
                  month[this.state.selectedTab === 'Units' ? 'unit_value' : 'revenue_value'],
                  this.state.phasingToggle === 'Vertical'
                    ? calculateVerticalWeekTotal(dataSource.rows, qIdx, mIdx, this.state.selectedTab)
                    : calculateQuarterTotal(quarter.months, this.state.selectedTab)
                );

                return {
                  ...month,
                  isNew: false,
                  value: Math.round(month[this.state.selectedTab === 'Units' ? 'unit_value' : 'revenue_value']),
                  oldValue: Math.round(month[this.state.selectedTab === 'Units' ? 'unit_value' : 'revenue_value']),
                  pctValue: pctW,
                  pctOldValue: pctW,
                  pctTotal: 0,
                  comparisionPctValue: calculatePercentageValue(
                    month[this.state.selectedTab === 'Units'
                      ? `unit_${this.state.comparisionMetrics}`
                      : `revenue_${this.state.comparisionMetrics}`],
                    this.state.phasingToggle === 'Vertical'
                      ? calculateVerticalWeekTotalComparision(dataSource.rows, qIdx, mIdx, this.state.selectedTab, this.state.comparisionMetrics)
                      : calculateQuarterTotalComparision(quarter.months, this.state.selectedTab, this.state.comparisionMetrics)
                  )
                };
              })
            };
          })
        };
      })
    };

    const updatedData = {
      columns: data.columns,
      rows: data.rows.map((row, rIdx: number) => {
        const grandTotal = this.state.phasingToggle === 'Vertical'
          ? calculateVerticalTotalPct(data.rows)
          : 0;

        return {
          ...row,
          pctValue: data.rows.length - 1 !== rIdx
            ? row.pctValue
            : (row.pctValue
              ? parseFloat(OneDecimalPlace(row.pctValue += (100 - grandTotal)).toString())
              : 0),
          quarters: row.quarters.map((quarter, qIdx: number) => {
            const quarterTotal = this.state.phasingToggle === 'Vertical'
              ? calculateVerticalQuarterPct(data.rows, qIdx)
              : calculateQuarterPct(data.rows, rIdx, qIdx);

            return {
              ...quarter,
              pctValue: data.rows.length - 1 !== rIdx
                ? quarter.pctValue
                : (quarter.pctValue
                  ? parseFloat(OneDecimalPlace(quarter.pctValue += (100 - quarterTotal)).toString())
                  : 0),
              months: quarter.months.map((month, mIdx: number) => {
                const weekTotal = this.state.phasingToggle === 'Vertical'
                  ? calculateVerticalWeekPct(data.rows, qIdx, mIdx)
                  : calculateQuarterPct(data.rows, rIdx, qIdx);

                if (data.rows.length - 1 !== rIdx) {
                  return { ...month };
                } else {
                  return {
                    ...month,
                    pctValue: month.pctValue
                      ? parseFloat(OneDecimalPlace(month.pctValue += (100 - weekTotal)).toString())
                      : 0
                  };
                }
              })
            };
          })
        };
      })
    };

    const extraRowData = dataSource.rows
      .filter((row, rowIdx: number) => rowIdx === 0)
      .map((row) => {
        return {
          ...row,
          oldValue: row.value,
          name: 'Total',
          quarters: row.quarters.map((quarter, qIdx: number) => {
            return {
              ...quarter,
              oldValue: calculateVerticalQuarterTotal(dataSource.rows, qIdx, this.state.selectedTab),
              value: calculateVerticalQuarterTotal(dataSource.rows, qIdx, this.state.selectedTab),
              pctValue: calculatePercentageValue(
                calculateVerticalQuarterTotal(dataSource.rows, qIdx, this.state.selectedTab),
                calculateGrandTotal(
                  quarter.isPast
                    ? dataSource.rows
                    : dataSource.rows.map((row) => {
                      return {
                        ...row,
                        ...row.quarters
                        //quarters: row.quarters.filter((quarter) => !quarter.isPast)
                      };
                    }),
                  this.state.selectedTab
                )
              ),
              comparisionPctValue: calculatePercentageValue(
                calculateVerticalQuarterTotalComparision(dataSource.rows, qIdx, this.state.selectedTab, this.state.comparisionMetrics),
                calculateGrandTotalComparision(
                  quarter.isPast
                    ? dataSource.rows
                    : dataSource.rows.map((row) => {
                      return {
                        ...row,
                        ...row.quarters
                        //quarters: row.quarters.filter((quarter) => !quarter.isPast)
                      };
                    }),
                  this.state.selectedTab,
                  this.state.comparisionMetrics
                )
              ),
              months: quarter.months.map((month, mIdx: number) => {
                return {
                  ...month,
                  value: calculateVerticalWeekTotal(dataSource.rows, qIdx, mIdx, this.state.selectedTab),
                  oldValue: calculateVerticalWeekTotal(dataSource.rows, qIdx, mIdx, this.state.selectedTab),
                  pctValue: calculatePercentageValue(
                    calculateVerticalWeekTotal(dataSource.rows, qIdx, mIdx, this.state.selectedTab),
                    calculateVerticalQuarterTotal(dataSource.rows, qIdx, this.state.selectedTab)
                  ),
                  comparisionPctValue: calculatePercentageValue(
                    calculateVerticalWeekTotalComparision(dataSource.rows, qIdx, mIdx, this.state.selectedTab, this.state.comparisionMetrics),
                    calculateVerticalQuarterTotalComparision(dataSource.rows, qIdx, this.state.selectedTab, this.state.comparisionMetrics)
                  )
                };
              })
            };
          })
        };
      });

    this.setState({
      dataSource: updatedData,
      extraRow: extraRowData
    }, () => {
      this.props.UpdatePhasingDataSource(this.state.dataSource.rows);
      this.props.UpdatePhasingType(this.state.selectedTab.toLocaleUpperCase());
    });
  }

  onExpandColumn(colName: string, isExpanded: boolean): void {
    const columns = [...this.state.dataSource.columns];
    columns.map((col) => {
      col.isExpanded = (colName === col.name) ? !isExpanded : false;
      return col;
    });

    const rows = [...this.state.dataSource.rows];
    rows.map((row) => {
      return {
        ...row,
        quarters: row.quarters.map((quarter) => {
          quarter.isExpanded = (colName === quarter.name) ? !isExpanded : false;
          return quarter;
        })
      }
    });

    const extraRow = [...this.state.extraRow];
    extraRow.map((row) => {
      return {
        ...row,
        quarters: row.quarters.map((quarter) => {
          quarter.isExpanded = (colName === quarter.name) ? !isExpanded : false;
          return quarter;
        })
      }
    });

    this.setState({
      dataSource: {
        ...this.state.dataSource,
        columns,
        rows
      },
      extraRow
    });
  }

  isColumnExpanded(): boolean {
    return this.state.dataSource.columns.reduce((acc, col) => acc || col.isExpanded, false);
  }

  updateWeekCalculation(rowIdx: number, quarterIdx: number, monthIdx: number, event): void {
    const value = event.target.value !== '' ? parseFloat(event.target.value) : '';

    this.state.dataSource.rows[rowIdx].quarters[quarterIdx].months[monthIdx].isEdited = true;
    this.state.dataSource.rows[rowIdx].quarters[quarterIdx].months[monthIdx].pctValue = value || 0;
    this.state.dataSource.rows[rowIdx].quarters[quarterIdx].months[monthIdx].isNew = true;

    if (this.state.phasingToggle === 'Vertical') {
      // this.state.dataSource.rows[rowIdx].isEdited = true;
      const verticalWeekTotal =
        calculateVerticalWeekTotal(this.state.dataSource.rows, quarterIdx, monthIdx, this.state.selectedTab);

      const unEditedCount = this.state.dataSource.rows.reduce((acc, row) => {
        acc += !row.quarters[quarterIdx].months[monthIdx].isEdited ? 1 : 0;
        return acc;
      }, 0);

      const totalEditedValue = this.state.dataSource.rows.reduce((rowInit, row) => {
        rowInit += row.quarters
          .filter((quarter, qIdx: number) => !quarter.isEdited && quarterIdx === qIdx)
          .reduce((quarterInit, quarter) => {
            quarterInit += quarter.months
              .filter((month, mIdx: number) => month.isEdited && mIdx === monthIdx)
              .reduce((monthInit, month) => {
                monthInit += month.pctValue;
                return monthInit;
              }, 0);
            return quarterInit;
          }, 0);
        return rowInit;
      }, 0);
      const totalUneditedValue = this.state.dataSource.rows.reduce((rowInit, row) => {
        rowInit += row.quarters
          .filter((quarter, qIdx: number) => !quarter.isEdited && quarterIdx === qIdx)
          .reduce((quarterInit, quarter) => {
            quarterInit += quarter.months
              .filter((month, mIdx: number) => !month.isEdited && monthIdx === mIdx)
              .reduce((monthInit, month) => {
                monthInit += month.pctOldValue;
                return monthInit;
              }, 0);
            return quarterInit;
          }, 0);
        return rowInit;
      }, 0);

      this.state.dataSource.rows[rowIdx].quarters[quarterIdx].months[monthIdx].pctTotal = totalEditedValue;

      const totalRemainingAfterEdit = 100 - totalEditedValue;

      this.state.dataSource.rows.forEach((row) => {
        row.quarters
          .filter((quarter, qIdx: number) => !quarter.isEdited && quarterIdx === qIdx)
          .forEach((quarter) => {
            quarter.months
              .filter((month, mIdx: number) => !month.isEdited && monthIdx === mIdx)
              .forEach((month) => {
                month.pctValue = totalEditedValue <= 100
                  ? OneDecimalPlace((month.pctOldValue / totalUneditedValue) * totalRemainingAfterEdit) || 0
                  : 0;
                month.isNew = true;
              });
          });
      });

      const totalPct = calculateVerticalWeekPct(this.state.dataSource.rows, quarterIdx, monthIdx);
      if (totalPct !== 100) {
        const uneditedIdx = this.state.dataSource.rows.findIndex((row) => !row.isEdited);
        let pctValue = this.state.dataSource.rows[uneditedIdx].quarters[quarterIdx].months[monthIdx].pctValue;
        pctValue = OneDecimalPlace(pctValue + (100 - totalPct));
        this.state.dataSource.rows[uneditedIdx].quarters[quarterIdx].months[monthIdx].pctValue =
          totalEditedValue <= 100 ? pctValue : 0;
      }

      this.state.dataSource.rows.forEach((row) => {
        const total = verticalWeekTotal * (row.quarters[quarterIdx].months[monthIdx].pctValue / 100);
        row.quarters[quarterIdx].months[monthIdx].value =
          this.state.selectedTab === 'Units' ? Math.round(total) : OneDecimalPlace(total);
        row.quarters[quarterIdx].months[monthIdx][this.state.selectedTab === 'Units' ? 'unit_value' : 'revenue_value'] =
          row.quarters[quarterIdx].months[monthIdx].value;
      });

      this.state.dataSource.rows.forEach((row) => {
        row.value = calculateProductGrandTotal(row.quarters, this.state.selectedTab);
        row.quarters[quarterIdx].value = calculateQuarterTotal(row.quarters[quarterIdx].months, this.state.selectedTab);
      });

      const currTotal = calculateVerticalWeekTotal(this.state.dataSource.rows, quarterIdx, monthIdx, this.state.selectedTab);
      const length = this.state.dataSource.rows.length;
      this.state.dataSource.rows[length - 1].quarters[quarterIdx].months[monthIdx]
        [this.state.selectedTab === 'Units' ? 'unit_value' : 'revenue_value'] += (verticalWeekTotal - currTotal);

      if (unEditedCount === 1) {
        this.state.dataSource.rows.forEach((row, rIdx: number) => {
          const indexOfUnEditedCell = row.quarters[quarterIdx].months
            .findIndex((month, mIdx: number) => !month.isEdited && monthIdx === mIdx);
          if (indexOfUnEditedCell > -1) {
            this.state.dataSource.rows[rIdx].quarters[quarterIdx].months[indexOfUnEditedCell].isDisabled = true;
          }
        });
      }
    } else {
      const horizontalWeekTotal = calculateQuarterTotal(
        this.state.dataSource.rows[rowIdx].quarters[quarterIdx].months.filter((month) => !month.isPast),
        this.state.selectedTab
      );

      const unEditedCount = this.state.dataSource.rows[rowIdx].quarters[quarterIdx].months
        .filter((month) => !month.isPast && !month.isEdited).length;

      const totalEditedValue = this.state.dataSource.rows[rowIdx].quarters[quarterIdx].months
        .filter((month) => !month.isPast && month.isEdited)
        .reduce((init, month) => {
          init += month.pctValue;
          return init;
        }, 0);
      const totalUneditedValue = this.state.dataSource.rows[rowIdx].quarters[quarterIdx].months
        .filter((month) => !month.isPast && !month.isEdited)
        .reduce((init, month) => {
          init += month.pctOldValue;
          return init;
        }, 0);

      this.state.dataSource.rows[rowIdx].quarters[quarterIdx].months[monthIdx].pctTotal = totalEditedValue;

      const totalRemainingAfterEdit = 100 - totalEditedValue;

      this.state.dataSource.rows[rowIdx].quarters[quarterIdx].months
        .filter((month) => !month.isPast && !month.isEdited)
        .forEach((month) => {
          month.pctValue = totalEditedValue <= 100
            ? OneDecimalPlace((month.pctOldValue / totalUneditedValue) * totalRemainingAfterEdit) || 0
            : 0;
          month.isNew = true;
        });

      const totalPct = calculateQuarterPct(this.state.dataSource.rows, rowIdx, quarterIdx);
      if (totalPct !== 100) {
        const uneditedIdx = this.state.dataSource.rows[rowIdx].quarters[quarterIdx].months
          .findIndex((month) => !month.isEdited);
        let pctValue = this.state.dataSource.rows[rowIdx].quarters[quarterIdx].months[uneditedIdx].pctValue;
        pctValue = OneDecimalPlace(pctValue + (100 - totalPct));
        this.state.dataSource.rows[rowIdx].quarters[quarterIdx].months[uneditedIdx].pctValue =
          totalEditedValue <= 100 ? pctValue : 0;
      }

      this.state.dataSource.rows[rowIdx].quarters[quarterIdx].months.forEach((month) => {
        const total = horizontalWeekTotal * (month.pctValue / 100);
        month[this.state.selectedTab === 'Units' ? 'unit_value' : 'revenue_value'] =
          this.state.selectedTab === 'Units' ? Math.round(total) : OneDecimalPlace(total);
      });

      const currTotal = calculateQuarterTotal(this.state.dataSource.rows[rowIdx].quarters[quarterIdx].months, this.state.selectedTab);
      const length = this.state.dataSource.rows[rowIdx].quarters[quarterIdx].months.length;
      this.state.dataSource.rows[rowIdx].quarters[quarterIdx].months[length - 1]
        [this.state.selectedTab === 'Units' ? 'unit_value' : 'revenue_value'] += (horizontalWeekTotal - currTotal);

      if (unEditedCount === 1) {
        const indexOfUnEditedCell = this.state.dataSource.rows[rowIdx].quarters[quarterIdx].months
          .findIndex((month) => !month.isPast && !month.isEdited);
        if (indexOfUnEditedCell > -1) {
          this.state.dataSource.rows[rowIdx].quarters[quarterIdx].months[indexOfUnEditedCell].isDisabled = true;
        }
      }
    }

    this.props.UpdateEditRestriction(true);
    this.setState({ dataSource: this.state.dataSource });
  }

  updateQuarterCalculation(rowIdx: number, quarterIdx: number, event): void {
    const value = event.target.value !== '' ? parseFloat(event.target.value) : '';

    this.state.dataSource.rows[rowIdx].quarters[quarterIdx].isEdited = !!value;
    this.state.dataSource.rows[rowIdx].quarters[quarterIdx].pctValue = value;
    this.state.dataSource.rows[rowIdx].quarters[quarterIdx].isNew = true;
    this.state.dataSource.rows.forEach((row) => {
      row.quarters[quarterIdx].months.forEach((month) => month.isNew = true);
    });

    if (this.state.phasingToggle === 'Vertical') {
      // this.state.dataSource.rows[rowIdx].isEdited = true;
      const verticalQuarterTotal = calculateVerticalQuarterTotal(this.state.dataSource.rows, quarterIdx, this.state.selectedTab);

      const unEditedCount = this.state.dataSource.rows.reduce((acc, row) => {
        acc += !row.quarters[quarterIdx].isEdited ? 1 : 0;
        return acc;
      }, 0);

      const totalEditedValue = this.state.dataSource.rows.reduce((acc, row) => {
        acc += row.quarters
          .filter((quarter, qIdx: number) => !quarter.isPast && quarter.isEdited && quarterIdx === qIdx)
          .reduce((init, quarter) => {
            init += quarter.pctValue;
            return init;
          }, 0);
        return acc;
      }, 0);
      const totalUneditedValue = this.state.dataSource.rows.reduce((acc, row) => {
        acc += row.quarters
          .filter((quarter, qIdx: number) => !quarter.isPast && !quarter.isEdited && quarterIdx === qIdx)
          .reduce((init, quarter) => {
            init += quarter.pctOldValue;
            return init;
          }, 0);
        return acc;
      }, 0);

      this.state.dataSource.rows[rowIdx].quarters[quarterIdx].pctTotal = totalEditedValue;

      const totalRemainingAfterEdit = 100 - totalEditedValue;

      this.state.dataSource.rows.forEach((row) => {
        row.quarters
          .filter((quarter, qIdx: number) => !quarter.isPast && !quarter.isEdited && quarterIdx === qIdx)
          .forEach((quarter) => {
            quarter.pctValue = totalEditedValue <= 100
              ? OneDecimalPlace((quarter.pctOldValue / totalUneditedValue) * totalRemainingAfterEdit) || 0
              : 0;
            quarter.isNew = true;
          });
      });

      const totalPct = calculateVerticalQuarterPct(this.state.dataSource.rows, quarterIdx);
      if (totalPct !== 100) {
        const uneditedIdx = this.state.dataSource.rows.findIndex((row) => !row.isEdited);
        let pctValue = this.state.dataSource.rows[uneditedIdx].quarters[quarterIdx].pctValue;
        pctValue = OneDecimalPlace(pctValue + (100 - totalPct));
        this.state.dataSource.rows[uneditedIdx].quarters[quarterIdx].pctValue =
          totalEditedValue <= 100 ? pctValue : 0;
      }

      this.state.dataSource.rows.forEach((row) => {
        row.quarters
          .filter((quarter, qIdx: number) => !quarter.isPast && quarterIdx === qIdx)
          .forEach((quarter) => {
            const total = verticalQuarterTotal * ((quarter.pctValue || 0) / 100);
            quarter.value = this.state.selectedTab === 'Units' ? Math.round(total) : OneDecimalPlace(total);
          });
      });

      this.state.dataSource.rows.forEach((row) => {
        row.value = row.quarters.reduce((acc, quarter) => {
          acc += quarter.value;
          return acc;
        }, 0);
      });

      if (unEditedCount === 1) {
        let indexOfUnEditedCell;
        this.state.dataSource.rows.forEach((row, rIdx: number) => {
          indexOfUnEditedCell = row.quarters
            .findIndex((quarter, qIdx: number) => !quarter.isPast && !quarter.isEdited && quarterIdx === qIdx);
          if (indexOfUnEditedCell > -1) {
            this.state.dataSource.rows[rIdx].quarters[indexOfUnEditedCell].isDisabled = true;
          }
        });
      }
    } else {
      const horizontalQuarterTotal = calculateProductGrandTotal(
        this.state.dataSource.rows[rowIdx].quarters,
        this.state.selectedTab
      );

      const unEditedCount = this.state.dataSource.rows[rowIdx].quarters
        .filter((quarter) => !quarter.isPast && quarter.isEdited).length;

      const totalEditedValue = this.state.dataSource.rows[rowIdx].quarters
        .filter((quarter) => !quarter.isPast && quarter.isEdited)
        .reduce((init, quarter) => {
          init += quarter.pctValue;
          return init;
        }, 0);
      const totalUneditedValue = this.state.dataSource.rows[rowIdx].quarters
        .filter((quarter) => !quarter.isPast && !quarter.isEdited)
        .reduce((init, quarter) => {
          init += quarter.pctOldValue;
          return init;
        }, 0);

      this.state.dataSource.rows[rowIdx].quarters[quarterIdx].pctTotal = totalEditedValue;

      const totalIspastQuarterValue = this.state.dataSource.rows[rowIdx].quarters
        .filter((quarter) => quarter.isPast)
        .reduce((init, quarter) => {
          init += quarter.pctValue;
          return init;
        }, 0);

      const totalRemainingAfterEdit = 100 - totalIspastQuarterValue - totalEditedValue;

      this.state.dataSource.rows[rowIdx].quarters
        .filter((quarter) => !quarter.isPast && !quarter.isEdited)
        .forEach((quarter) => {
          quarter.pctValue = totalEditedValue <= 100
            ? OneDecimalPlace((quarter.pctOldValue / totalUneditedValue) * totalRemainingAfterEdit) || 0
            : 0;
          quarter.isNew = true;
        });

      const totalPct = calculateHorizontalQuarterPct(this.state.dataSource.rows, rowIdx);
      if (totalPct !== 100) {
        const length = this.state.dataSource.rows[rowIdx].quarters.length;
        let pctValue = this.state.dataSource.rows[rowIdx].quarters[length - 1].pctValue;
        pctValue = OneDecimalPlace(pctValue + (100 - totalPct));
        this.state.dataSource.rows[rowIdx].quarters[length - 1].pctValue =
          totalEditedValue <= 100 ? pctValue : 0;
      }

      this.state.dataSource.rows[rowIdx].quarters
        .filter((quarter) => !quarter.isPast)
        .forEach((quarter) => {
          const total = horizontalQuarterTotal * (quarter.pctValue / 100);
          quarter.value = this.state.selectedTab === 'Units' ? Math.round(total) : OneDecimalPlace(total);
        });

      this.state.extraRow[0].quarters.forEach((quarter, qIdx) => {
        quarter.value = this.state.dataSource.rows.reduce((acc, row) => {
          acc += row.quarters[qIdx].value;
          return acc;
        }, 0);
      });

      if (unEditedCount === 1) {
        const indexOfUnEditedCell = this.state.dataSource.rows[rowIdx].quarters
          .findIndex((quarter) => !quarter.isPast && !quarter.isEdited);
        if (indexOfUnEditedCell > -1) {
          this.state.dataSource.rows[rowIdx].quarters[indexOfUnEditedCell].isDisabled = true;
        }
      }
    }

    this.props.UpdateEditRestriction(true);
    this.setState({
      dataSource: this.state.dataSource,
      extraRow: this.state.extraRow
    });
  }

  updateVerticalTotalCalculation(rowIdx: number, event): void {
    const value = event.target.value !== '' ? parseFloat(event.target.value) : '';

    this.state.dataSource.rows[rowIdx].isEdited = true;
    this.state.dataSource.rows[rowIdx].pctValue = value || 0;
    this.state.dataSource.rows.forEach((row) => row.quarters
      .filter((quarter) => !quarter.isPast)
      .forEach((quarter) => {
        quarter.isNew = true;
        quarter.months.forEach((month) => month.isNew = true)
      }));

    const grandTotal = calculateGrandTotal(this.state.dataSource.rows, this.state.selectedTab);

    const unEditedCount = this.state.dataSource.rows.reduce((acc, row) => {
      acc += !row.isEdited ? 1 : 0;
      return acc;
    }, 0);

    const totalEditedValue = this.state.dataSource.rows
      .filter((row) => row.isEdited)
      .reduce((acc, row) => {
        acc += row.pctValue;
        return acc;
      }, 0);
    const totalUneditedValue = this.state.dataSource.rows
      .filter((row) => !row.isEdited)
      .reduce((acc, row) => {
        acc += row.pctOldValue;
        return acc;
      }, 0);

    this.state.dataSource.rows[rowIdx].pctTotal = totalEditedValue;

    const totalRemainingAfterEdit = 100 - totalEditedValue;

    this.state.dataSource.rows
      .filter((row) => !row.isEdited)
      .forEach((row) => {
        row.pctValue = totalEditedValue <= 100
          ? OneDecimalPlace((row.pctOldValue / totalUneditedValue) * totalRemainingAfterEdit) || 0
          : 0;
      });

    const totalPct = calculateVerticalTotalPct(this.state.dataSource.rows);
    if (totalPct !== 100) {
      const uneditedIdx = this.state.dataSource.rows.findIndex((row) => !row.isEdited);
      let pctValue = this.state.dataSource.rows[uneditedIdx].pctValue;
      pctValue = OneDecimalPlace(pctValue + (100 - totalPct));
      this.state.dataSource.rows[uneditedIdx].pctValue = totalEditedValue <= 100 ? pctValue : 0;
    }

    this.state.dataSource.rows.forEach((row) => {
      const total = grandTotal * (row.pctValue / 100);
      row.value = this.state.selectedTab === 'Units' ? Math.round(total) : OneDecimalPlace(total);
    });

    const verticalTotal = calculateVerticalTotal(this.state.dataSource.rows, this.state.selectedTab);
    const length = this.state.dataSource.rows.length;

    let rowValue = this.state.dataSource.rows[length - 1].value;
    if (rowValue) {
      rowValue += (grandTotal - verticalTotal);
      this.state.dataSource.rows[length - 1].value = rowValue;
    }

    this.state.dataSource.rows.forEach((row) => {
      row.quarters
        .filter((quarter) => !quarter.isPast)
        .forEach((quarter) => {
          const total = row.value *
            (quarter.oldValue / (row.isEdited
                ? calculateHorizontalPrevValue(row.quarters, this.state.selectedTab)
                : calculateProductGrandTotal(row.quarters, this.state.selectedTab)
            ));
          quarter.value = this.state.selectedTab === 'Units' ? (Math.round(total) || 0) : (OneDecimalPlace(total) || 0);
        });
    });

    this.state.dataSource.rows.forEach((row) => {
      row.quarters
        .filter((quarter) => !quarter.isPast)
        .forEach((quarter) => {
          quarter.pctValue = verticalTotal !== 0 ? OneDecimalPlace((quarter.value / verticalTotal) * 100) : 0;
        });
    });

    if (unEditedCount === 1) {
      const indexOfUnEditedCell = this.state.dataSource.rows.findIndex((row) => !row.isEdited);
      if (indexOfUnEditedCell > -1) {
        this.state.dataSource.rows[indexOfUnEditedCell].isDisabled = true;
      }
    }

    this.props.UpdateEditRestriction(true);
    this.setState({ dataSource: this.state.dataSource });
  }

  updateHorizontalQuarterTotalCalculation(rowIdx: number, quarterIdx: number, event) {
    const value = event.target.value !== '' ? parseFloat(event.target.value) : '';

    this.state.extraRow[rowIdx].quarters[quarterIdx].isEdited = true;
    this.state.extraRow[rowIdx].quarters[quarterIdx].pctValue = value || 0;

    const grandTotal = calculateGrandTotal(this.state.dataSource.rows, this.state.selectedTab);

    const unEditedCount = this.state.extraRow[rowIdx].quarters
      .filter((quarter) => !quarter.isPast && quarter.isEdited).length;

    const totalEditedValue = this.state.extraRow[rowIdx].quarters
      .filter((quarter) => !quarter.isPast && quarter.isEdited)
      .reduce((init, quarter) => {
        init += quarter.pctValue;
        return init;
      }, 0);
    const totalUneditedValue = this.state.extraRow[rowIdx].quarters
      .filter((quarter) => !quarter.isPast && !quarter.isEdited)
      .reduce((init, quarter) => {
        init += quarter.pctValue;
        return init;
      }, 0);

    this.state.dataSource.rows[rowIdx].quarters[quarterIdx].pctTotal = totalEditedValue;

    const totalIspastQuarterValue = this.state.extraRow[rowIdx].quarters
      .filter((quarter) => quarter.isPast)
      .reduce((init, quarter) => {
        init += quarter.pctValue;
        return init;
      }, 0);

    const totalRemainingAfterEdit = 100 - totalIspastQuarterValue - totalEditedValue;

    this.state.extraRow[rowIdx].quarters
      .filter((quarter) => !quarter.isPast && !quarter.isEdited)
      .forEach((quarter) => {
        quarter.pctValue = totalEditedValue <= 100
          ? OneDecimalPlace((quarter.pctValue / totalUneditedValue) * totalRemainingAfterEdit) || 0
          : 0;
      });

    this.state.extraRow[rowIdx].quarters
      .filter((quarter) => !quarter.isPast)
      .forEach((quarter) => {
        const total = grandTotal * (quarter.pctValue / 100);
        quarter.value = this.state.selectedTab === 'Units' ? Math.round(total) : OneDecimalPlace(total);
      });

    this.state.dataSource.rows.forEach((row) => {
      row.quarters.filter((q) => !q.isPast)
        .forEach((q) => {

          this.state.extraRow[rowIdx].quarters
            .filter((quarter) => !quarter.isPast && quarter.name === q.name)
            .forEach((quarter) => {
              if (!quarter.isEdited) {
                quarter.pctValue = totalEditedValue <= 100 ? OneDecimalPlace(quarter.pctValue) || 0 : 0;
              }
              const newValue = quarter.value;
              const oldValue = quarter.oldValue;

              q.value = this.state.selectedTab === 'Units'
                ? Math.round(newValue * (q.oldValue / oldValue))
                : OneDecimalPlace(newValue * (q.oldValue / oldValue));
              q.isNew = true;

            });
        });
    });

    const totalPct = calculateHorizontalQuarterPct(this.state.extraRow, rowIdx);
    if (totalPct !== 100) {
      const uneditedIdx = this.state.extraRow[rowIdx].quarters.findIndex((quarter) => !quarter.isEdited);
      let pctValue = this.state.extraRow[rowIdx].quarters[uneditedIdx].pctValue;
      pctValue = OneDecimalPlace(pctValue + (100 - totalPct));
      this.state.extraRow[rowIdx].quarters[uneditedIdx].pctValue = totalEditedValue <= 100 ? pctValue : 0;
    }

    this.state.extraRow.forEach((row) => {
      row.quarters
        .filter((quarter) => !quarter.isPast)
        .forEach((quarter) => {
          quarter.value =
            this.state.selectedTab === 'Units'
              ? Math.round(grandTotal * ((quarter.pctValue || 0) / 100))
              : OneDecimalPlace(grandTotal * ((quarter.pctValue || 0) / 100));
        });
    });

    this.state.dataSource.rows.forEach((row) => {
      row.value = row.quarters.reduce((acc, quarter) => {
        acc += quarter.value;
        return acc;
      }, 0);
    });

    if (unEditedCount === 1) {
      const indexOfUnEditedCell = this.state.extraRow[rowIdx].quarters
        .findIndex((quarter) => !quarter.isPast && !quarter.isEdited);
      if (indexOfUnEditedCell > -1) {
        this.state.extraRow[rowIdx].quarters[indexOfUnEditedCell].isDisabled = true;
      }
    }

    this.props.UpdateEditRestriction(true);
    this.setState({
      dataSource: this.state.dataSource,
      extraRow: this.state.extraRow
    });
  }

  updateHorizontalWeekTotalCalculation(rowIdx: number, quarterIdx: number, monthIdx: number, event): void {
    const value = event.target.value !== '' ? parseFloat(event.target.value) : '';

    this.state.extraRow[rowIdx].quarters[quarterIdx].months[monthIdx].isEdited = true;
    this.state.extraRow[rowIdx].quarters[quarterIdx].months[monthIdx].pctValue = value || 0;

    const horizontalWeekTotal = calculateHorizontalPrevValue(
      this.state.extraRow[rowIdx].quarters[quarterIdx].months,
      this.state.selectedTab
    );

    const unEditedCount = this.state.extraRow[rowIdx].quarters[quarterIdx].months
      .filter((month) => !month.isPast && !month.isEdited).length;

    const totalEditedValue = this.state.extraRow[rowIdx].quarters[quarterIdx].months
      .filter((month) => !month.isPast && month.isEdited)
      .reduce((init, month) => {
        init += month.pctValue;
        return init;
      }, 0);
    const totalUneditedValue = this.state.extraRow[rowIdx].quarters[quarterIdx].months
      .filter((month) => !month.isPast && !month.isEdited)
      .reduce((init, month) => {
        init += month.pctValue;
        return init;
      }, 0);

    this.state.dataSource.rows[rowIdx].quarters[quarterIdx].months[monthIdx].pctTotal = totalEditedValue;

    const totalRemainingAfterEdit = 100 - totalEditedValue;

    this.state.extraRow[rowIdx].quarters[quarterIdx].months
      .filter((month) => !month.isPast && !month.isEdited)
      .forEach((month) => {
        month.pctValue = OneDecimalPlace((month.pctValue / totalUneditedValue) * totalRemainingAfterEdit) || 0;
      });

    const totalPct = calculateQuarterPct(this.state.extraRow, rowIdx, quarterIdx);
    if (totalPct !== 100) {
      const uneditedIdx = this.state.extraRow[rowIdx].quarters[quarterIdx].months.findIndex((month) => !month.isEdited);
      let pctValue = this.state.extraRow[rowIdx].quarters[quarterIdx].months[uneditedIdx].pctValue;
      pctValue = OneDecimalPlace(pctValue + (100 - totalPct));
      this.state.extraRow[rowIdx].quarters[quarterIdx].months[uneditedIdx].pctValue = totalEditedValue <= 100 ? pctValue : 0;
    }

    this.state.extraRow[rowIdx].quarters[quarterIdx].months
      .forEach((month) => {
        const total = horizontalWeekTotal * (month.pctValue / 100);
        month[this.state.selectedTab === 'Units' ? 'unit_value' : 'revenue_value'] =
          this.state.selectedTab === 'Units' ? Math.round(total) : OneDecimalPlace(total);
      });

    const currTotal = calculateQuarterTotal(this.state.extraRow[rowIdx].quarters[quarterIdx].months, this.state.selectedTab);
    const length = this.state.extraRow[rowIdx].quarters[quarterIdx].months.length;
    this.state.extraRow[rowIdx].quarters[quarterIdx].months[length - 1]
      [this.state.selectedTab === 'Units' ? 'unit_value' : 'revenue_value'] += (horizontalWeekTotal - currTotal);

    if (unEditedCount === 1) {
      const indexOfUnEditedCell = this.state.extraRow[rowIdx].quarters[quarterIdx].months
        .findIndex((month) => !month.isPast && !month.isEdited);
      if (indexOfUnEditedCell > -1) {
        this.state.extraRow[rowIdx].quarters[quarterIdx].months[indexOfUnEditedCell].isDisabled = true;
      }
    }

    this.state.dataSource.rows.forEach((row) => {
      row.quarters[quarterIdx].months.forEach((month, mIdx: number) => {
        const total = this.state.extraRow[0].quarters[quarterIdx].months[mIdx].value;
        const oldTotal = this.state.extraRow[0].quarters[quarterIdx].months[mIdx].oldValue;
        month.value =
          (
            this.state.selectedTab === 'Units'
              ? Math.round(total * (month.oldValue / oldTotal))
              : OneDecimalPlace(total * (month.oldValue / oldTotal))
          );
        month[this.state.selectedTab === 'Units' ? 'unit_value' : 'revenue_value'] = month.value;
        month.isNew = true;
      });
    });

    this.props.UpdateEditRestriction(true);
    this.setState({
      dataSource: this.state.dataSource,
      extraRow: this.state.extraRow
    });
  }

  updatePhasingData(isFreezeRequired: boolean): void {
    let payload: IPhasingPayload[] = [];

    const isQuarterExpanded = !!this.state.dataSource.rows
      .filter((row) => !!row.quarters
        .filter((quarter) => quarter.isExpanded).length).length;

    if (!isQuarterExpanded) {
      payload = this.state.dataSource.rows
        .filter((row) => row.quarters
          .filter((quarter) => quarter.isNew).length)
        .map((row) => {
          return {
            name: row.name,
            quarters: row.quarters
              .filter((quarter) => quarter.isNew)
              .map((quarter) => {
                const monthLength = quarter.months.length;
                const isValidForecast = quarter.months[monthLength - 1].forecastVal > 0;

                const quarterPayload = {
                  name: quarter.name,
                  ratioSelection: getRatioSelectionOfPhasingGrid(quarter, this.state.selectedTab, isValidForecast),
                };

                this.state.selectedTab === 'Units'
                  ? quarterPayload['unit_value'] = quarter.value
                  : quarterPayload['revenue_value'] = quarter.value;

                return quarterPayload;
              })
          };
        });
    } else {
      payload = this.state.dataSource.rows
        .filter((row) => row.quarters
          .filter((quarter) => quarter.months
            .filter((month) => month.isNew).length).length)
        .map((row) => {
          return {
            name: row.name,
            quarters: row.quarters
              .filter((quarter) => !!quarter.months
                .filter((month) => month.isNew).length)
              .map((quarter) => {
                const monthLength = quarter.months.length;
                const isValidForecast = quarter.months[monthLength - 1].forecastVal > 0;

                return {
                  name: quarter.name,
                  months: quarter.months
                    .filter((month) => month.isNew)
                    .map((month) => {
                      const weekPayload = {
                        name: month.name,
                        ratioSelection: getRatioSelectionOfPhasingGrid(month, this.state.selectedTab, isValidForecast),
                      };

                      this.state.selectedTab === 'Units'
                        ? weekPayload['unit_value'] = month.unit_value
                        : weekPayload['revenue_value'] = month.revenue_value;

                      return weekPayload;
                    })
                };
              })
          };
        });
    }

    const params = {
      userId: sessionStorage.getItem('userName'),
      planId: GetPlanId(this.props.history.location.pathname)
    };

    this.props.onUpdateStart();

    UpdatePhasingData(payload, params)
      .then((res) => {
        if (!!res && res != 'running') {
          this.setState({
            editCells: false,
            editTotal: false,
            isLoading: true
          }, () => {
            if (isFreezeRequired) {
              this.freezePlan();
            } else {
              this.props.onUpdateEnd();
              this.props.UpdateEditRestriction(false);
            }
          });
        } else if (!!res && res === 'running') {
          this.setState({ isRunningModal: true });
          this.props.onLoadEnd();
          this.props.onRunningEnd();
          this.setState({
            editTotal: false,
            editCells: false
          }, () => {
            this.dataInit();
            this.props.onUpdateEnd();
          });
          this.props.UpdateEditRestriction(false);
        }
      });
  }

  freezePlan(): void {
    const params = {
      userId: sessionStorage.getItem('userName'),
      planId: GetPlanId(this.props.history.location.pathname)
    };

    this.props.onUpdateStart();

    FreezePlan(params)
      .then(() => {
        this.props.onUpdateEnd();
        this.props.UpdateEditRestriction(false);
      });
  }

  saveButtonValidity(): boolean {
    const totalCheck = this.state.dataSource.rows.reduce((rInit, row) => rInit && row.pctTotal <= 100, true);

    const quarterCheck = this.state.dataSource.rows
      .reduce((rInit, row) => rInit && row.quarters
        .reduce((qInit, quarter) => qInit && quarter.pctTotal <= 100, true), true);

    const weekCheck = this.state.dataSource.rows
      .reduce((rInit, row) => rInit && row.quarters
        .reduce((qInit, quarter) => qInit && quarter.months
          .reduce((wInit, month) => wInit && month.pctTotal <= 100, true), true), true);

    return totalCheck && quarterCheck && weekCheck;
  }

  render(): React.ReactNode {
    if (this.state.isLoading) {
      return null;
    }

    if (this.state.isAutoLoad) {
      return <InitialMessage/>;
    }

    if (!this.state.isLoading && this.state.originalDataSource.rows.length === 0) {
      return <NoDataFound/>;
    }

    if (!this.validateJSON()) {
      return <InvalidData/>;
    }

    const headerSection = <Card className="section-header-card">
      <Row>
        <Col md={1} className="align-self-center">
          <div className="d-flex">
            <p className="table-title">Phasing</p>
            <img src={InfoIcon} alt="info-icon" className="cursor-pointer"/>
          </div>
        </Col>

        <Col md={2} className="d-flex justify-content-center align-self-center">
          <div className="d-flex">
            {
              ['Units', 'Revenue'].map((data, tabIdx: number) => (
                <div
                  key={tabIdx}
                  className={`tab ${data === this.state.selectedTab ? 'active' : ''}`}
                  onClick={() => {
                    this.props.isAllowed
                      ? this.setState({ isEditRestrictionAllowed: true })
                      : this.setState({
                        selectedTab: data
                      }, () => this.dataInit());
                  }}
                >
                  <p className={`tab-text tab-text-sm ${data === this.state.selectedTab ? 'active' : ''}`}>
                    {data}
                  </p>
                </div>
              ))
            }
          </div>
        </Col>

        <Col md={3}>
          <div className="custom-form-container">
            <label htmlFor="comparision-metrics" className="custom-form-label">Comparision metrics</label>
            <select
              id="comparision-metrics"
              className="custom-drop-down-field"
              onChange={(e) => {
                this.props.isAllowed
                  ? this.setState({ isEditRestrictionAllowed: true })
                  : this.setState({ isEditRestrictionAllowed: false });
                this.setState({
                  comparisionMetrics: e.target.value === 'None' ? '' : e.target.value
                }, () => {
                  this.dataInit();
                });
              }}
            >
              {
                this.state.comparisionMetricsList.map((data, idx) => (
                  <option
                    key={idx}
                    value={data.value}
                  >
                    {data.label}
                  </option>
                ))
              }
            </select>
          </div>
        </Col>

        <Col md={5} className="align-self-center">
          <div className="custom-form-container">
            <label className="custom-form-label">Phasing Toggle</label>

            <div className="d-flex align-items-center me-3">
              <Input
                id="vertical"
                name="Phasing Toggle"
                type="radio"
                checked={this.state.phasingToggle === 'Vertical'}
                onChange={() => {
                  this.props.isAllowed
                    ? this.setState({ isEditRestrictionAllowed: true })
                    : this.setState({
                      phasingToggle: 'Vertical'
                    }, () => this.dataInit());
                }}
              />
              <Label for="vertical" check>Product Contribution</Label>
            </div>

            <div className="d-flex align-items-center">
              <Input
                id="horizontal"
                name="Phasing Toggle"
                type="radio"
                checked={this.state.phasingToggle === 'Horizontal'}
                onChange={() => {
                  this.props.isAllowed
                    ? this.setState({ isEditRestrictionAllowed: true })
                    : this.setState({
                      phasingToggle: 'Horizontal'
                    }, () => this.dataInit());
                }}
              />
              <Label for="horizontal" check>Time Contribution</Label>
            </div>
          </div>
        </Col>

        <Col md={1} className="text-right">
          <i className={`ri-arrow-${this.state.isExpanded ? 'up' : 'down'}-s-line ps-1 cursor-pointer`}
             style={{ fontSize: '22px' }}
             onClick={() => this.setState({ isExpanded: !this.state.isExpanded })}
          />
        </Col>
      </Row>
    </Card>;
    const bodySection = <div className={`table-responsive phase-table-outline custom-table ${styles['phasing-table']}`}>
      <Table className="mb-0">
        <thead>
        <tr>
          <th className="dark-bg-cell text-right">
            <Tooltip
              content={'Edit measures'}
              direction={'left'}
            >
              <div className="action-btn">
                <img
                  src={EditIcon}
                  alt="edit-icon"
                  className="edit-icon-position"
                  onClick={() => {
                    this.props.isAllowed
                      ? this.setState({ isEditRestrictionAllowed: true })
                      : (!this.state.editTotal && this.setState({ editCells: true }))
                  }}
                />
              </div>
            </Tooltip>
          </th>
          {
            this.state.dataSource.columns.map((col, colIdx: number) => (
              <th
                key={colIdx}
                colSpan={col.isExpanded ? totalWeeksOfSelectedQuarter(this.state.dataSource.rows, colIdx) : 1}
                className={col.isPast ? 'dark-bg-cell' : ''}
              >
                <span
                  className="toggle-col"
                >
                  {col.name}
                  {
                    !col.isPast &&
                    <i className={`${col.isExpanded ? 'ri-checkbox-indeterminate-fill' : 'ri-add-box-fill'} ms-sm-2`}
                       onClick={() => {
                         this.props.isAllowed
                           ? this.setState({ isEditRestrictionAllowed: true })
                           : this.onExpandColumn(col.name, col.isExpanded);
                       }}
                    />
                  }
                </span>
              </th>
            ))
          }
          {
            this.state.phasingToggle === 'Horizontal' &&
            <th>Total of edit</th>
          }
          <th className={this.state.phasingToggle === 'Horizontal' ? 'phasing-toggle-bg' : 'dark-bg-cell'}>
            <div className="d-flex justify-content-between align-items-center">
              Total
              {
                this.state.phasingToggle === 'Vertical' &&
                <Tooltip
                  content={'Edit measures'}
                  direction={'left'}
                >
                  <div className="action-btn">
                    <img
                      src={EditIcon}
                      alt="edit-icon"
                      className="edit-icon-position"
                      onClick={() => {
                        this.props.isAllowed
                          ? this.setState({ isEditRestrictionAllowed: true })
                          : (!this.state.editCells && this.setState({ editTotal: true }))
                      }}
                    />
                  </div>
                </Tooltip>
              }
            </div>
          </th>
        </tr>

        {
          this.isColumnExpanded() &&
          <React.Fragment>
            <tr>
              <th className="dark-bg-cell"/>
              {
                this.state.dataSource.columns.map((quarter, qIdx: number) => (
                  <React.Fragment key={qIdx}>
                    {
                      quarter.isExpanded
                        ? quarter.months.map((month, mIdx: number) => (
                          <React.Fragment key={mIdx}>
                            <th className="text-center">
                              {month.name}
                            </th>
                            {
                              quarter.months.length - 1 === mIdx &&
                              <th className="dark-bg-cell text-center">Total</th>
                            }
                          </React.Fragment>
                        ))
                        : <th/>
                    }
                  </React.Fragment>
                ))
              }
              {
                this.state.phasingToggle === 'Horizontal' && <th/>
              }
              <th className={this.state.phasingToggle === 'Horizontal' ? 'phasing-toggle-bg' : 'dark-bg-cell'}/>
            </tr>
          </React.Fragment>
        }
        </thead>

        <tbody>
        {
          this.state.dataSource.rows.map((row, rowIdx: number) => (
            <tr key={rowIdx}>
              <td className="text-right dark-bg-cell table-data-text">{row.desc}</td>
              {
                !this.isColumnExpanded()
                  ? row.quarters.map((quarter, qIdx: number) => (
                    <td key={qIdx}>
                      {
                        (this.state.editCells && !quarter.isPast)
                          ? <input
                            type="number"
                            className={
                              `${(quarter.isEdited)
                                ? 'editable-input-new'
                                : 'editable-input'} ${quarter.isDisabled && ' readonly-input'}`
                            }
                            readOnly={quarter.isDisabled}
                            onChange={(e) => this.updateQuarterCalculation(rowIdx, qIdx, e)}
                            value={quarter.pctValue}
                          />
                          : quarter.pctValue
                      }%
                      {
                        ['ly', 'lq'].indexOf(this.state.comparisionMetrics) !== -1 &&
                        <span className="d-block text-success">
                          {quarter.comparisionPctValue}%
                        </span>
                      }
                      ({quarter.value}) {/*Actual Value*/}
                    </td>
                  ))
                  : row.quarters.map((quarter, qIdx: number) => (
                    <React.Fragment key={qIdx}>
                      {
                        quarter.isExpanded &&
                        quarter.months.map((month, mIdx: number) => (
                          <td key={mIdx}>
                            {
                              (this.state.editCells && !month.isPast)
                                ? <input
                                  type="number"
                                  className={
                                    `${(month.isEdited)
                                      ? 'editable-input-new'
                                      : 'editable-input'} ${month.isDisabled && ' readonly-input'}`
                                  }
                                  readOnly={month.isDisabled}
                                  onChange={(e) => this.updateWeekCalculation(rowIdx, qIdx, mIdx, e)}
                                  value={month.pctValue}
                                />
                                : month.pctValue
                            }%
                            ({month.value}) {/*Actual Value*/}
                            {
                              ['ly', 'lq'].indexOf(this.state.comparisionMetrics) !== -1 &&
                              <span className="d-block text-success">
                                {month.comparisionPctValue}%
                              </span>
                            }
                          </td>
                        ))
                      }
                      <td className={(quarter.isExpanded || quarter.isPast) ? 'dark-bg-cell' : ''}>
                        {quarter.pctValue}%
                        {
                          ['ly', 'lq'].indexOf(this.state.comparisionMetrics) !== -1 &&
                          <span className="d-block text-success">
                            {quarter.comparisionPctValue}%
                          </span>
                        }
                        ({quarter.value}) {/*Actual Value*/}
                      </td>
                    </React.Fragment>
                  ))
              }
              {
                this.state.phasingToggle === 'Horizontal' &&
                <td className={
                  !this.isColumnExpanded()
                    ? (
                      (calculateTotalHorizontalQuarterEdit(this.state.dataSource.rows, rowIdx) <= 100)
                        ? 'text-success'
                        : 'text-danger'
                    )
                    : (
                      (calculateTotalHorizontalWeekEdit(this.state.dataSource.rows, rowIdx) <= 100)
                        ? 'text-success'
                        : 'text-danger'
                    )
                }>
                  {
                    !this.isColumnExpanded()
                      ? calculateTotalHorizontalQuarterEdit(this.state.dataSource.rows, rowIdx)
                      : calculateTotalHorizontalWeekEdit(this.state.dataSource.rows, rowIdx)
                  }%
                </td>
              }
              <td className={`${
                this.state.phasingToggle === 'Horizontal'
                  ? 'phasing-toggle-bg'
                  : 'dark-bg-cell'} table-data-text text-right`}>
                {
                  this.state.phasingToggle === 'Vertical'
                    ? (
                      this.state.editTotal
                        ? <input
                          type="number"
                          className={
                            `${(row.isEdited)
                              ? 'editable-input-new'
                              : 'editable-input'} ${row.isDisabled && ' readonly-input'}`
                          }
                          readOnly={row.isDisabled}
                          onChange={(e) => this.updateVerticalTotalCalculation(rowIdx, e)}
                          value={row.pctValue}
                        />
                        : row.pctValue
                    )
                    : 100
                }%
                ({row.value}) {/*Actual Value*/}
                {
                  this.state.phasingToggle === 'Vertical' &&
                  ['ly', 'lq'].indexOf(this.state.comparisionMetrics) !== -1 &&
                  <span className="d-block text-success">
                    {row.comparisionPctValue}%
                  </span>
                }
              </td>
            </tr>
          ))
        }
        {
          this.state.phasingToggle === 'Vertical' &&
          this.state.dataSource.rows
            .filter((row, rowIdx: number) => rowIdx === 0)
            .map((row, rowIdx: number) => (
              <tr key={rowIdx}>
                <td className="text-right dark-bg-cell table-data-text">Total of edit</td>
                {
                  !this.isColumnExpanded()
                    ? row.quarters.map((quarter, qIdx: number) => (
                      <td
                        className={
                          (calculateTotalVerticalQuarterEdit(this.state.dataSource.rows, qIdx) <= 100)
                            ? 'text-success'
                            : 'text-danger'
                        }
                        key={qIdx}
                      >
                        {calculateTotalVerticalQuarterEdit(this.state.dataSource.rows, qIdx)}%
                      </td>
                    ))
                    : row.quarters.map((quarter, qIdx: number) => (
                      <React.Fragment key={qIdx}>
                        {
                          quarter.isExpanded &&
                          quarter.months.map((month, mIdx: number) => (
                            <td
                              key={mIdx}
                              className={
                                (calculateTotalVerticalWeekEdit(this.state.dataSource.rows, qIdx, mIdx) <= 100)
                                  ? 'text-success'
                                  : 'text-danger'
                              }
                            >
                              {calculateTotalVerticalWeekEdit(this.state.dataSource.rows, qIdx, mIdx)}%
                            </td>
                          ))
                        }
                        <td className={`${(quarter.isExpanded || quarter.isPast) ? 'dark-bg-cell' : 'text-danger'}`}>
                          0%
                        </td>
                      </React.Fragment>
                    ))
                }
                <td className={
                  `${this.state.phasingToggle === 'Horizontal'
                    ? 'phasing-toggle-bg'
                    : 'dark-bg-cell text-right '}
                    ${(calculateTotalVerticalEdit(this.state.dataSource.rows) <= 100)
                    ? 'text-success'
                    : 'text-danger'}`
                }>
                  {calculateTotalVerticalEdit(this.state.dataSource.rows)}%
                </td>
              </tr>
            ))
        }

        {
          this.state.extraRow.map((row, rowIdx: number) => (
            <tr
              key={rowIdx}
              className={this.state.phasingToggle === 'Vertical' ? styles['total-bg-color'] : ''}
            >
              <td className={`d-flex justify-content-end align-items-center table-data-text
              ${this.state.phasingToggle === 'Vertical'
                ? styles['total-bg-color']
                : 'dark-bg-cell'}`
              }>
                {row.name}
                {
                  this.state.phasingToggle === 'Horizontal' &&
                  <Tooltip
                    content={'Edit measures'}
                    direction={'left'}
                  >
                    <div className="action-btn">
                      <img
                        src={EditIcon}
                        alt="edit-icon"
                        className="edit-icon-position"
                        onClick={() => {
                          this.props.isAllowed
                            ? this.setState({ isEditRestrictionAllowed: true })
                            : (!this.state.editCells && this.setState({ editTotal: true }))
                        }}
                      />
                    </div>
                  </Tooltip>
                }
              </td>
              {
                !this.isColumnExpanded()
                  ? row.quarters.map((quarter, qIdx: number) => (
                    <td
                      key={qIdx}
                      className={
                        `${(this.state.phasingToggle === 'Horizontal')
                          ? 'disabled-cell'
                          : ''} table-data-text`
                      }>
                      {
                        this.state.phasingToggle === 'Vertical'
                          ? 100
                          : (
                            (this.state.editTotal && !quarter.isPast)
                              ? <input
                                type="number"
                                className={
                                  `${(quarter.isEdited)
                                    ? 'editable-input-new'
                                    : 'editable-input'} ${quarter.isDisabled && ' readonly-input'}`
                                }
                                readOnly={quarter.isDisabled}
                                onChange={(e) => this.updateHorizontalQuarterTotalCalculation(rowIdx, qIdx, e)}
                                value={quarter.pctValue}
                              />
                              : quarter.pctValue
                          )
                      }%
                      ({quarter.value}) {/*Actual Value*/}
                      {
                        this.state.phasingToggle === 'Horizontal' &&
                        ['ly', 'lq'].indexOf(this.state.comparisionMetrics) !== -1 &&
                        <span className="d-block text-success">
                          {quarter.comparisionPctValue}%
                        </span>
                      }
                    </td>
                  ))
                  : row.quarters.map((quarter, qIdx: number) => (
                    <React.Fragment key={qIdx}>
                      {
                        quarter.isExpanded &&
                        quarter.months.map((month, mIdx: number) => (
                          <td
                            key={mIdx}
                            className="table-data-text"
                          >
                            {
                              this.state.phasingToggle === 'Vertical'
                                ? 100
                                : (
                                  this.state.editTotal && !month.isPast
                                    ? <input
                                      type="number"
                                      className={
                                        `${(month.isEdited)
                                          ? 'editable-input-new'
                                          : 'editable-input'} ${month.isDisabled && ' readonly-input'}`
                                      }
                                      readOnly={month.isDisabled}
                                      onChange={(e) => this.updateHorizontalWeekTotalCalculation(rowIdx, qIdx, mIdx, e)}
                                      value={month.pctValue}
                                    />
                                    : month.pctValue
                                )
                            }%
                            ({calculateVerticalWeekTotal(this.state.dataSource.rows, qIdx, mIdx, this.state.selectedTab)}) {/*Actual Value*/}
                            {
                              this.state.phasingToggle === 'Horizontal' &&
                              ['ly', 'lq'].indexOf(this.state.comparisionMetrics) !== -1 &&
                              <span className="d-block text-success">
                                {month.comparisionPctValue}%
                              </span>
                            }
                          </td>
                        ))
                      }
                      <td className={
                        `${(quarter.isExpanded)
                          ? (this.state.phasingToggle === 'Vertical' ? styles['total-bg-color'] : 'dark-bg-cell')
                          : ''} table-data-text`
                      }>
                        {this.state.phasingToggle === 'Vertical' ? 100 : quarter.pctValue}%
                        ({calculateVerticalQuarterTotal(this.state.dataSource.rows, qIdx, this.state.selectedTab)}) {/*Actual Value*/}
                        {
                          this.state.phasingToggle === 'Horizontal' &&
                          ['ly', 'lq'].indexOf(this.state.comparisionMetrics) !== -1 &&
                          <span className="d-block text-success">
                            {quarter.comparisionPctValue}%
                          </span>
                        }
                      </td>
                    </React.Fragment>
                  ))
              }
              {
                this.state.phasingToggle === 'Horizontal' &&
                <td className={
                  !this.isColumnExpanded()
                    ? (calculateTotalHorizontalQuarterEdit(this.state.extraRow, rowIdx) <= 100) ? 'text-success' : 'text-danger'
                    : (calculateTotalHorizontalWeekEdit(this.state.extraRow, rowIdx) <= 100) ? 'text-success' : 'text-danger'
                }>
                  {
                    !this.isColumnExpanded()
                      ? calculateTotalHorizontalQuarterEdit(this.state.extraRow, rowIdx)
                      : calculateTotalHorizontalWeekEdit(this.state.extraRow, rowIdx)
                  }%
                </td>
              }
              <td className={`text-right table-data-text ${styles['total-bg-color']}`}>
                100%
                ({calculateGrandTotal(this.state.dataSource.rows, this.state.selectedTab)}) {/*Actual Value*/}
              </td>
            </tr>
          ))
        }
        </tbody>
      </Table>
    </div>;

    return (
      <React.Fragment>
        {headerSection}
        {this.state.isExpanded && bodySection}

        {
          (this.state.editTotal || this.state.editCells) &&
          <ActionCard
            onCancel={() => {
              this.setState({
                editTotal: false,
                editCells: false
              }, () => {
                this.dataInit();
              });
              this.props.UpdateEditRestriction(false);
            }}
            onSave={() => this.updatePhasingData(false)}
            onSaveAndFreeze={() => this.updatePhasingData(true)}
            isSaveDisabled={!this.saveButtonValidity()}
            // isSaveAndFreezeDisabled={!this.saveFreezeButtonValidity()}
          />
        }

        <UnsavedDataModal
          isOpen={this.state.isEditRestrictionAllowed}
          toggle={() => this.setState({ isEditRestrictionAllowed: !this.state.isEditRestrictionAllowed })}
          removeChanges={() => {
            this.props.UpdateEditRestriction(false);
            this.setState({
              editTotal: false,
              editCells: false,
              isEditRestrictionAllowed: false
            }, () => {
              this.dataInit();
            });
          }}
        />
        <SuccessModal
          isOpen={this.state.isRunningModal}
          toggle={() => this.setState({ isRunningModal: !this.state.isRunningModal, isLoading: false })}
          message={'Another user using same filters for saving, Please try after sometime'}
        />

      </React.Fragment>
    );
  }
}

const mapStateToProps = (state: any): StateProps => {
  return {
    ...state.EditRestriction,
    ...state.PhasingDataSource,
    ...state.PhasingType
  };
};

export default connect<StateProps, DispatchProps, OwnProps>
(mapStateToProps, {
  UpdateEditRestriction,
  UpdatePhasingDataSource,
  UpdatePhasingType
})(withRouter(PhasingTable));
